if ( typeof ProductPage !== 'function' ) {

	class ProductPage extends HTMLElement {

		constructor(){

			super();
			this.locationProduct = [];
			this.variantData = [];
			this.variantID = null;
			this.productGallery = this.querySelector('[data-js-product-gallery]');
			this.productSlider = this.querySelector('css-slider');
			this.variantSelector = document.querySelector('variant-selector');

			this.pickupAvailabilityCompact = this.querySelector('pickup-availability-compact');
			this.pickupAvailabilityExtended = this.querySelector('pickup-availability-extended');

			this.variantInventoryPolicy = JSON.parse(
				this.querySelector('[data-js-variant-inventory-policy]')?.textContent || '[]'
			);

			this.storeSelector = document.querySelector('#site-store-selector-handle [data-store-label]');


			// Gallery thumbnails

			if ( this.productSlider ) {

				const productGaleryThumbnails = this.querySelector('.product-gallery__thumbnails-holder');

				if ( this.querySelector('.product-gallery__thumbnails .thumbnail[data-index]') ) {

					this.querySelectorAll('.product-gallery__thumbnails .thumbnail[data-index]').forEach((elm, i)=>{
						if ( i == 0 )  {
							elm.classList.add('active');
						}
						elm.addEventListener('click',e=>{
							if ( this.productSlider.sliderEnabled ) {
								this.productSlider.changeSlide(e.currentTarget.dataset.index);
							} else {
								window.scrollTo({
									top: this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`).offsetTop + this.offsetTop,
									behavior: 'smooth'
								});
								this.thumbnailNavigationHelper(e.currentTarget.dataset.index);
							}
							this._pauseAllMedia();
							this._playMedia(this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`));
							productGaleryThumbnails.scrollTo({
								left: elm.offsetLeft - 50,
								behaviour: 'smooth'
							})
						});
					})

					this.productSlider.addEventListener('change', e=>{
						this.thumbnailNavigationHelper(e.target.index);
					});

				}

				this.productSlider.addEventListener('navigation', e=>{
					this._playMedia(this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`));
				})
				this.productSlider.addEventListener('change', e=>{
					this._pauseAllMedia();
					if ( this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.productMediaType == 'model' ) {
						if ( this.xrButton ) {
							this.xrButton.setAttribute('data-shopify-model3d-id', this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.mediaId);
						}
						setTimeout(()=>{
							this.productSlider.querySelector('.css-slider-holder').classList.add('css-slider--disable-dragging');
						}, 150);
					}
				});

				// Parallax

				this.productSlider.addEventListener('ready', (e)=>{

					if ( this.firstProductGalleryIndex ) {
						const initialVariantMedia = this.productGallery?.querySelector(
							`.product-gallery-item[data-index="${this.firstProductGalleryIndex}"]`
						);
						this.showGalleryItem(initialVariantMedia, this.productGallery, 'auto');
					}

					const productSlides = this.productSlider.querySelectorAll('.product-gallery-item');
					const productFigures = this.querySelectorAll('.apply-gallery-animation');
					this.productSlider.addEventListener('scroll', ()=>{
						const scrollX = -this.productSlider.element.scrollLeft;
						productSlides.forEach((slide,i)=>{
							const media = productFigures[i];
							if ( media ) {
								media.style.transform = `translateX(${( slide.offsetLeft + scrollX ) * -1/3}px)`;
							}
						});
					});

				});

			}

			// Product variant event listener for theme specific logic

			this.productVariants = this.querySelector('product-variants');
			if ( this.productVariants ) {
				this.productVariants.addEventListener('VARIANT_CHANGE', this.onVariantChangeHandler.bind(this));
				this.onVariantChangeHandler({target:this.productVariants});
			}
			const initializeInventory = () => {
				this.inventoryText = this.querySelectorAll('[data-js-product-inventory]');
                document.addEventListener('storechanged', () => this.updateVariantsAndInventory());
				this.updateVariantsAndInventory();
			};
			if (document.readyState === 'loading') {
				window.addEventListener('DOMContentLoaded', initializeInventory, { once: true });
			} else {
				initializeInventory();
			}
			// show cart drawer when element is added to cart

			if ( ! document.body.classList.contains('template-cart') && KROWN.settings.cart_action == 'overlay' ) {

				let addToCartEnter = false;
				if ( this.querySelector('[data-js-product-add-to-cart]') ) {
					this.querySelector('[data-js-product-add-to-cart]').addEventListener('keyup', e=>{
						if ( e.keyCode == window.KEYCODES.RETURN ) {
							addToCartEnter = true;
						}
					})
				}

				if ( this.querySelector('[data-js-product-form]') ) {
					this.querySelector('[data-js-product-form]').addEventListener('add-to-cart', ()=>{
						document.getElementById('site-cart-sidebar').show();
						if ( document.getElementById('cart-recommendations') ) {
							document.getElementById('cart-recommendations').generateRecommendations();
						}
						if ( addToCartEnter ) {
							setTimeout(()=>{
								document.querySelector('#site-cart-sidebar [data-js-close]').focus();
							}, 200);
						}
					});
				}

			}

			// Check for models

			const models = this.querySelectorAll('product-model');
			if ( models.length > 0 ) {
				window.ProductModel.loadShopifyXR();
				this.xrButton = this.querySelector('.product-gallery__view-in-space');
			}

			// hide buy now button if stock disabled

			const addToCartButton = this.querySelector('[data-js-product-add-to-cart]');
			if ( addToCartButton ) {
				if ( addToCartButton.classList.contains('disabled') ) {
					this.querySelector('product-form').classList.add('disable-buy-button');
				} else {
					this.querySelector('product-form').classList.remove('disable-buy-button');
				}
				const buyObserver = new MutationObserver(()=>{
					if ( addToCartButton.classList.contains('disabled') ) {
						this.querySelector('product-form').classList.add('disable-buy-button');
					} else {
						this.querySelector('product-form').classList.remove('disable-buy-button');
					}
				});
				buyObserver.observe(addToCartButton,{ attributes: true, childList: false, subtree: false });
			}

			// update secondary price if present

			this.priceCompact = this.querySelector('[data-js-product-price-compact]');
			this.priceExtended = this.querySelector('[data-js-product-price-extended]');

			if ( this.priceCompact ) {
				this.priceCompact.priceOriginal = this.priceCompact.querySelector('[data-js-product-price-original]');
				this.priceCompact.priceCompare = this.priceCompact.querySelector('[data-js-product-price-compare]');
				this.priceCompact.priceUnit = this.priceCompact.querySelector('[data-js-product-price-unit]');
				this.priceCompact.priceSaving = this.priceCompact.querySelector('[data-js-flash-sale-saving]');
			}
			if ( this.priceExtended ) {
				this.priceExtended.priceOriginal = this.priceExtended.querySelector('[data-js-product-price-original]');
				this.priceExtended.priceCompare = this.priceExtended.querySelector('[data-js-product-price-compare]');
				this.priceExtended.priceUnit = this.priceExtended.querySelector('[data-js-product-price-unit]');
				this.priceExtended.priceSaving = this.priceExtended.querySelector('[data-js-flash-sale-saving]');
			}

          	if (this.storeSelector) {
				this.storeSelectorObserver = new MutationObserver(() => {
					this.updateVariantsAndInventory();
				});
				this.storeSelectorObserver.observe(this.storeSelector, { attributes: true, childList: true, subtree: true });
			}

		}

		thumbnailNavigationHelper(index=0){
			this.querySelectorAll('.product-gallery__thumbnails .thumbnail[data-index]').forEach((elm, i)=>{
				if ( i == index )
					elm.classList.add('active');
				else
					elm.classList.remove('active');
			});
		}

		showGalleryItem(variantImg, gallery = this.productGallery, behavior = 'smooth'){
			if ( !variantImg || !gallery ) return false;

			const index = Number(variantImg.dataset.index);
			if ( !Number.isFinite(index) ) return false;

			const slider = gallery.querySelector('css-slider');
			const holder = slider?.querySelector('.css-slider-holder');
			const indexedItems = slider?.indexedItems ? Array.from(slider.indexedItems) : [];

			if ( slider?.sliderEnabled && indexedItems[index] && typeof slider.changeSlide === 'function' ) {
				slider.changeSlide(index, behavior);
			} else if ( holder ) {
				const firstSlide = holder.querySelector('.product-gallery-item');
				const firstOffset = firstSlide?.offsetLeft || 0;
				holder.scrollTo({
					top: 0,
					left: Math.max(0, variantImg.offsetLeft - firstOffset),
					behavior
				});

				if ( slider ) {
					slider.index = index;
					if ( slider.viewport && slider.o?.autoHeight ) {
						slider.viewport.style.height = `${variantImg.offsetHeight}px`;
					}
				}
			} else {
				this.firstProductGalleryIndex = index;
				return false;
			}

			gallery.querySelectorAll('.product-gallery-item').forEach(item => {
				item.classList.toggle('css-slide-active', item === variantImg);
			});
			this.thumbnailNavigationHelper(index);
			return true;
		}

		updatePoints(variant){
			if ( !variant || typeof variant.price !== 'number' ) {
				return;
			}

			const points = Math.floor(variant.price / 100);

			this.querySelectorAll('[data-js-product-points-count]').forEach((elm)=>{
				elm.textContent = `${points} reps`;
			});

			this.querySelectorAll('[data-js-product-points-title]').forEach((elm)=>{
				const template = elm.dataset.pointsTemplate;
				if ( template ) {
					elm.innerHTML = template.split('__POINTS__').join(points);
				}
			});
		}

		updateRechargeVisibility(variant){
			const productText = this.querySelector('[data-recharge-price-policy]');
			// ProductVariants initializes asynchronously. Preserve the Liquid-rendered
			// state until a concrete variant exists, then keep it in sync on changes.
			if ( ! productText || ! variant ) return;

			const compareAtPrice = Number(variant?.compare_at_price || 0);
			const price = Number(variant?.price || 0);
			const hasCompareAtDiscount = compareAtPrice > price;

			productText.classList.toggle('hideRecharge', hasCompareAtDiscount);
			productText.dataset.rechargeHidden = hasCompareAtDiscount ? 'true' : 'false';
		}

		updateSecondaryPrice(priceBlock, variant, extended = false){
			if ( !priceBlock ) return;

			const priceOriginal = priceBlock.priceOriginal;
			const priceCompare = priceBlock.priceCompare;
			const priceUnit = priceBlock.priceUnit;
			const priceSaving = priceBlock.priceSaving;

			if ( !variant ) {
				if ( priceOriginal ) priceOriginal.innerHTML = '';
				if ( priceCompare ) priceCompare.innerHTML = '';
				if ( priceUnit ) priceUnit.innerHTML = '';
				if ( priceSaving ) {
					priceSaving.textContent = '';
					priceSaving.hidden = true;
				}
				return;
			}

			const formatMoney = value => this.productVariants._formatMoney(value, KROWN.settings.shop_money_format);
			const compareAtPrice = Number(variant.compare_at_price || 0);
			const price = Number(variant.price || 0);
			const hasDiscount = compareAtPrice > price;
			const discountPercent = hasDiscount
				? Math.round(Math.abs((price * 100 / compareAtPrice) - 100))
				: 0;

			if ( priceOriginal ) priceOriginal.innerHTML = formatMoney(price);
			if ( priceCompare ) {
				if ( hasDiscount ) {
					if ( extended ) {
						const savingTemplate = KROWN.settings.locales?.product_compare_price || '$SAVE_PRICE';
						priceCompare.innerHTML = `<span>${formatMoney(compareAtPrice)}</span><span>${savingTemplate.replace('$SAVE_PRICE', formatMoney(compareAtPrice - price))}</span>`;
					} else {
						priceCompare.innerHTML = `<span>${formatMoney(compareAtPrice)}</span><span class="product-item__badge">-${discountPercent}%</span>`;
					}
				} else {
					priceCompare.innerHTML = '';
				}
			}

			if ( priceSaving ) {
				priceSaving.textContent = hasDiscount ? `-${discountPercent}%` : '';
				priceSaving.hidden = !hasDiscount;
			}

			if ( priceUnit ) {
				if ( variant.unit_price_measurement ) {
					priceUnit.innerHTML = `
						${formatMoney(variant.unit_price)} /
						${( variant.unit_price_measurement.reference_value != 1 ? variant.unit_price_measurement.reference_value + ' ' : '' )}
						${variant.unit_price_measurement.reference_unit}
					`;
				} else {
					priceUnit.innerHTML = '';
				}
			}
		}

		onVariantChangeHandler(e){
			let variant = e.target.currentVariant;
			this.variantID = variant?.id;
			this.updateRechargeVisibility(variant);
			if ( variant ) {

				// image handling

				if ( variant.featured_media != null ) {
					const galleries = Array.from(this.querySelectorAll('.product-gallery'));
					const visibleGallery = galleries.find(gallery => gallery.getClientRects().length > 0)
						|| this.productGallery
						|| galleries[0];
					let variantImg = visibleGallery?.querySelector('.product-gallery-item[data-media-id="' + variant.featured_media.id + '"]');
					if ( variantImg && visibleGallery ) {
						if ( visibleGallery.classList.contains('product-gallery--slider') || ( visibleGallery.classList.contains('product-gallery--scroll') && window.innerWidth < 1024 ) ) {
							this.showGalleryItem(variantImg, visibleGallery);
						} else {
							const headerOffset = Math.max(120, document.querySelector('header')?.offsetHeight || 0);
							window.scrollTo({
								top: variantImg.getBoundingClientRect().top + window.scrollY - headerOffset,
								behavior: 'smooth'
							});
						}

						this.thumbnailNavigationHelper(variantImg.dataset.index);
					}
				}

				// refresh pickup availability widgets

				if ( this.pickupAvailabilityCompact && this.pickupAvailabilityCompact.classList.contains('active') ) {
					this.querySelector('pickup-availability-compact').style.display = 'block';
					this.querySelector('pickup-availability-compact').fetchAvailability(variant.id);
				}

				if ( this.pickupAvailabilityExtended && this.pickupAvailabilityExtended.classList.contains('active') ) {
					this.querySelector('pickup-availability-extended').style.display = 'block';
					this.querySelector('pickup-availability-extended').fetchAvailability(variant.id);
				}

	
				this.updateInventoryText(variant.id);



			} else {

				if ( this.pickupAvailabilityCompact && this.pickupAvailabilityCompact.classList.contains('active') ) {
					this.querySelector('pickup-availability-compact').style.display = 'none';
				}

				if ( this.pickupAvailabilityExtended && this.pickupAvailabilityExtended.classList.contains('active') ) {
					this.querySelector('pickup-availability-extended').style.display = 'none';
				}

			}

			// update prices (overwrites the framework)

			this.updateSecondaryPrice(this.priceCompact, variant, false);
			this.updateSecondaryPrice(this.priceExtended, variant, true);

			this.updatePoints(variant);



		}
		async getLocation() {
			try {
				if (this.dataset.onlineInventoryOnly === 'true') return null;
				const token = window.KROWN.settings.storefront_api_key;
				const domain = window.KROWN.settings.store_domain;
					const productId = this.dataset.id || this.querySelector('[data-id]')?.getAttribute('data-id');
					if (!productId) return null;
		
					const data = await window.ShopSanteInventory.load({
						productId,
						domain,
						token,
					});

					if(!data.data.product) {
				console.error('Product not found')
				return
				}
			
				return data
			} catch (error) {
				console.error('Error fetching data:', error);
				return null;
			}
		}

        getLocationVariants() {
          const product = this.locationProduct?.data?.product;
          const location = window.ShopSanteInventory.storeName(product);
          return (product?.variants?.nodes || []).map(variant => ({
            variantId: String(variant.id).split('/').pop(),
            variantTitle: variant.title,
            quantity: window.ShopSanteInventory.state(variant, location).quantity,
            inventoryPolicy: window.ShopSanteInventory.state(variant, location).unlimited ? 'continue' : 'deny'
          }));
        }

		updateInventoryText() {

			

			if (!Array.isArray(this.variantData) || this.variantData.length === 0) {
				this.inventoryText?.forEach(el => el.innerHTML = '');
				return;
			}

			const id = this.variantID ? this.variantID : new URLSearchParams(window.location.search).get('variant') ? new URLSearchParams(window.location.search).get('variant') : this.variantData[0].variantId;
			
			const variant = this.variantData.find(v => v.variantId == id)
		
			if (!variant) {
				return;
			}
			
            const { quantity } = variant;
            const french = document.documentElement.lang?.toLowerCase().startsWith('fr');
            const stock = quantity === Infinity
              ? (french ? 'Plus de 200 en stock' : 'Over 200 in stock')
              : quantity > 0
              ? (quantity > 200 ? (french ? 'En stock' : 'In stock') : `${quantity} ${french ? 'en stock' : 'in stock'}`)
              : (french ? 'Épuisé' : 'Sold out');
            const location = this.dataset.onlineInventoryOnly === 'true'
              ? 'Shop Santé Inc.' : window.ShopSanteInventory.storeName(this.locationProduct?.data?.product);
            const label = location === 'Shop Santé Inc.'
              ? (french ? 'En ligne' : 'Online')
              : location.replace(/^Shop Santé /, '');
            this.inventoryText.forEach(el => {
              const status = document.createElement('span');
              status.className = 'product-stock-status';
              status.textContent = stock;
              el.replaceChildren(status);
              if (label) {
                const store = document.createElement('span');
                store.className = 'product-stock-location';
                store.textContent = label;
                el.append(store);
              }
            });
		}

		async updateVariantsAndInventory() {
			if (this.dataset.onlineInventoryOnly === 'true') {
				try {
					this.variantData = this.variantInventoryPolicy.map(variant => ({
						variantId: String(variant.id),
						quantity: variant.inventory === 'continue' && !variant.unavailable
							? Infinity : Math.max(0, Math.floor(Number(variant.quantity) || 0)),
						inventoryPolicy: variant.inventory || 'deny'
					}));
				} catch (_) {
					this.variantData = [];
				}
				this.updateInventoryText();
				return;
			}
            this.locationProduct = await this.getLocation();
			this.variantData = await this.getLocationVariants();
			this.updateInventoryText()
		}


		_pauseAllMedia(){

			document.querySelectorAll('.product-gallery .js-youtube').forEach(video => {
				video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
			});
			document.querySelectorAll('.product-gallery .js-vimeo').forEach(video => {
				video.contentWindow.postMessage('{"method":"pause"}', '*');
			});
			document.querySelectorAll('.product-gallery video').forEach(video => video.pause());
			document.querySelectorAll('.product-gallery product-model').forEach(model => {
				if ( model.modelViewerUI )
					model.modelViewerUI.pause()
			});
		}

		_playMedia(media){
			switch ( media.dataset.productMediaType ) {
				case 'video':
					if ( media.querySelector('video') ) {
						media.querySelector('video').play();
					}
					break;
				case 'external_video-youtube':
					if ( media.querySelector('.js-youtube') ) {
						media.querySelector('.js-youtube').contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
					}
					break;
				case 'external_video-vimeo':
					if ( media.querySelector('.js-vimeo') ) {
						media.querySelector('.js-vimeo').contentWindow.postMessage('{"method":"play"}', '*');
					}
					break;
			}
		}

	}

  if ( typeof customElements.get('product-page') == 'undefined' ) {
		customElements.define('product-page', ProductPage);
	}

}
